import { render, staticRenderFns } from "./ResetarSenha.vue?vue&type=template&id=a66b8a5e&scoped=true&"
import script from "./ResetarSenha.vue?vue&type=script&lang=js&"
export * from "./ResetarSenha.vue?vue&type=script&lang=js&"
import style0 from "./ResetarSenha.vue?vue&type=style&index=0&id=a66b8a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66b8a5e",
  null
  
)

export default component.exports